import React, { useState } from 'react';
import { DropdownButton, DropdownItem } from 'react-bootstrap';

function DropdownLastDays(props) {
  const [title, setValue] = useState('Todos');

  function renderTitle(eventKey) {
    const nextTitle = eventKey !== '1' ? `Últimos ${eventKey} días` : 'Todos';
    setValue(nextTitle);
    props.apply(eventKey !== '1' ? eventKey : null);
  }

  return (
    <DropdownButton title={title} onSelect={renderTitle} id="dropdown-days">
      <DropdownItem eventKey="1">Todos</DropdownItem>
      <DropdownItem eventKey="30">Últimos 30 días</DropdownItem>
      <DropdownItem eventKey="15">Últimos 15 días</DropdownItem>
      <DropdownItem eventKey="7">Últimos 7 días</DropdownItem>
    </DropdownButton>
  );
}
export default DropdownLastDays;
